module.exports = __webpack_public_path__ + "static/media/makemytrip.955fe31b.png";